// FETCH ALL PRINTING_DC_INWARD DETAILS
export const FETCH_PRINTING_DC_INWARD_DETAILS_REQUEST = 'FETCH_PRINTING_DC_INWARD_DETAILS_REQUEST';
export const FETCH_PRINTING_DC_INWARD_DETAILS_SUCCESS = 'FETCH_PRINTING_DC_INWARD_DETAILS_SUCCESS';
export const FETCH_PRINTING_DC_INWARD_DETAILS_FAILURE = 'FETCH_PRINTING_DC_INWARD_DETAILS_FAILURE';

// FETCH ALL PRINTING_DC_INWARD DETAILS
export const FETCH_PRINTING_DC_INWARD_DETAILS_WITHOUT_ID_REQUEST = 'FETCH_PRINTING_DC_INWARD_DETAILS_WITHOUT_ID_REQUEST';
export const FETCH_PRINTING_DC_INWARD_DETAILS_WITHOUT_ID_SUCCESS = 'FETCH_PRINTING_DC_INWARD_DETAILS_WITHOUT_ID_SUCCESS';
export const FETCH_PRINTING_DC_INWARD_DETAILS_WITHOUT_ID_FAILURE = 'FETCH_PRINTING_DC_INWARD_DETAILS_WITHOUT_ID_FAILURE';

// CREATE PRINTING_DC_INWARD DETAILS
export const CREATE_PRINTING_DC_INWARD_DETAILS_REQUEST = 'CREATE_PRINTING_DC_INWARD_DETAILS_REQUEST';
export const CREATE_PRINTING_DC_INWARD_DETAILS_SUCCESS = 'CREATE_PRINTING_DC_INWARD_DETAILS_SUCCESS';
export const CREATE_PRINTING_DC_INWARD_DETAILS_FAILURE = 'CREATE_PRINTING_DC_INWARD_DETAILS_FAILURE';

// UPDATE PRINTING_DC_INWARD DETAILS
export const UPDATE_PRINTING_DC_INWARD_DETAILS_REQUEST = 'UPDATE_PRINTING_DC_INWARD_DETAILS_REQUEST';
export const UPDATE_PRINTING_DC_INWARD_DETAILS_SUCCESS = 'UPDATE_PRINTING_DC_INWARD_DETAILS_SUCCESS';
export const UPDATE_PRINTING_DC_INWARD_DETAILS_FAILURE = 'UPDATE_PRINTING_DC_INWARD_DETAILS_FAILURE';

// FETCH SINGLE STATE OF PRINTING_DC_INWARD DETAILS
export const FETCH_SINGLE_PRINTING_DC_INWARD_DETAILS_REQUEST = 'FETCH_SINGLE_PRINTING_DC_INWARD_DETAILS_REQUEST';
export const FETCH_SINGLE_PRINTING_DC_INWARD_DETAILS_SUCCESS = 'FETCH_SINGLE_PRINTING_DC_INWARD_DETAILS_SUCCESS';
export const FETCH_SINGLE_PRINTING_DC_INWARD_DETAILS_FAILURE = 'FETCH_SINGLE_PRINTING_DC_INWARD_DETAILS_FAILURE';

// DELETE PRINTING_DC_INWARD DETAILS
export const DELETE_PRINTING_DC_INWARD_DETAILS_REQUEST = 'DELETE_PRINTING_DC_INWARD_DETAILS_REQUEST';
export const DELETE_PRINTING_DC_INWARD_DETAILS_SUCCESS = 'DELETE_PRINTING_DC_INWARD_DETAILS_SUCCESS';
export const DELETE_PRINTING_DC_INWARD_DETAILS_FAILURE = 'DELETE_PRINTING_DC_INWARD_DETAILS_FAILURE';

// FETCH ALL PROPERTIES FROM PRINTING_INWARD DETAILS
export const FETCH_PREVIOUS_PRINTING_INWARD_DETAILS_REQUEST = 'FETCH_PREVIOUS_PRINTING_INWARD_DETAILS_REQUEST';
export const FETCH_PREVIOUS_PRINTING_INWARD_DETAILS_SUCCESS = 'FETCH_PREVIOUS_PRINTING_INWARD_DETAILS_SUCCESS';
export const FETCH_PREVIOUS_PRINTING_INWARD_DETAILS_FAILURE = 'FETCH_PREVIOUS_PRINTING_INWARD_DETAILS_FAILURE';

export const RESET_PRINTING_DC_INWARD_DETAILS_INFO = 'RESET_PRINTING_DC_INWARD_DETAILS_INFO';

export const CREATE_PRINTING_DC_INWARD_DETAILS_FORM = 'CREATE_PRINTING_DC_INWARD_DETAILS_FORM';

export const UPDATE_PRINTING_DC_INWARD_DETAILS_FORM = 'UPDATE_PRINTING_DC_INWARD_DETAILS_FORM';

export const PRINTING_INWARD_DETAILS_PO_DETAILS_DISABLED = 'PRINTING_INWARD_DETAILS_PO_DETAILS_DISABLED';


export const FETCH_PRINTING_INWARD_DETAIL_EDIT_QTY_MASTER_REQUEST = 'FETCH_PRINTING_INWARD_DETAIL_EDIT_QTY_MASTER_REQUEST';
export const FETCH_PRINTING_INWARD_DETAIL_EDIT_QTY_MASTER_SUCCESS = 'FETCH_PRINTING_INWARD_DETAIL_EDIT_QTY_MASTER_SUCCESS';
export const FETCH_PRINTING_INWARD_DETAIL_EDIT_QTY_MASTER_FAILURE = 'FETCH_PRINTING_INWARD_DETAIL_EDIT_QTY_MASTER_FAILURE';

//CREATE USER FORM

export const CREATE_USER_FORM_PRINTING_INWARD_EDIT_QTY = 'CREATE_USER_FORM_PRINTING_INWARD_EDIT_QTY';

export const RESET_PRINTING_INWARD_EDIT_QTY = 'RESET_PRINTING_INWARD_EDIT_QTY';

export const RESET_EDIT_QUANTITY_GRID_DATA_WITHOUT_PRINTING_INWARD_ID = 'RESET_EDIT_QUANTITY_GRID_DATA_WITHOUT_PRINTING_INWARD_ID';
export const SET_EDIT_QUANTITY_GRID_DATA_WITHOUT_PRINTING_INWARD_ID = 'SET_EDIT_QUANTITY_GRID_DATA_WITHOUT_PRINTING_INWARD_ID';

export const PRINTING_INWARD_DETAILS_USERFORM_RESET = 'PRINTING_INWARD_DETAILS_USERFORM_RESET';
